/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "channelRelationDefs",
    graphQL: "ChannelRelationDef",
    name: "Application Relation Mapping",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'channelRelationDefs',
    defaultOrder: ['fromEntity_id', 'fromField_id', 'toEntity_id', 'toField_id'],
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Application Relation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        entityRelationDef: {
            name: "Entity Relation Definition",
            to: () => types['entityRelationDefs'],
            type: "relation",
            relativeTo: ['entityRelationEntityDef'],
        },
        entityRelationEntityDef: {
            name: "Entity Relation Definition Entity",
            to: () => types['entityDefs'],
            type: "relation",
        },
        fromEntity: {
            name: "Source Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        toEntity: {
            name: "Target Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        fromFieldEntity: {
            name: "Source Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        toFieldEntity: {
            name: "Target Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        fromField: {
            name: "Source Field Definition",
            to: () => types['fieldDefs'],
            type: "relation",
            required: true,
            relativeTo: ['fromFieldEntity'],
        },
        toField: {
            name: "Target Field Definition",
            to: () => types['fieldDefs'],
            type: "relation",
            required: true,
            relativeTo: ['toFieldEntity'],
        },
        fromWorksWithoutCache: {
            name: "From works without cache",
            type: "boolean",
            defaultValue: false,
            userEditable: false,
        },
        toWorksWithoutCache: {
            name: "To works without cache",
            type: "boolean",
            defaultValue: false,
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
